/**
 * Sahifa siljishini to'xtatish — HAMMA ustma-ust qatlamlar uchun BITTA joyda.
 *
 * Sanoq (`openCount`) umumiy bo'lishi SHART: modal ustida ochilgan rasm
 * ko'ruvchisi yopilganda, ostidagi modal hali ochiq bo'lsa ham siljish
 * tiklanib ketardi va ekran ortidagi hujjat qimirlab qolardi. Har qatlam
 * o'z sanog'ini yuritsa, aynan shu yuz beradi.
 */
/**
 * Ochiq qatlamlar SANOG'I.
 *
 * Ikki narsa uchun kerak: sahifa siljishini oxirgi qatlam yopilgandagina
 * tiklash, va ustma-ust tushgan qatlamni balandroq qavatga chiqarish.
 */
let openCount = 0;
/** Hozir ochiq bo'lgan qatlamlar soni — `z-index` ni hisoblash uchun. */
export const openLayerCount = () => openCount;
/**
 * Sahifa siljishini to'xtatadi va SIRG'ALUVCHI CHIZIQ o'rnini qoplaydi.
 *
 * `overflow: hidden` chiziqni yo'qotadi va sahifa uning kengligicha
 * o'ngga siljiydi — oyna ochilganda ortidagi butun matn qimirlab
 * ketardi. Shu kenglik `padding-right` bo'lib qaytariladi.
 */
export const lockBodyScroll = () => {
    const { body, documentElement } = document;
    openCount += 1;
    if (openCount > 1) {
        return () => {
            openCount -= 1;
        };
    }
    const previousOverflow = body.style.overflow;
    const previousPadding = body.style.paddingRight;
    const gap = window.innerWidth - documentElement.clientWidth;
    body.style.overflow = 'hidden';
    if (gap > 0)
        body.style.paddingRight = `${gap}px`;
    return () => {
        openCount -= 1;
        if (openCount > 0)
            return;
        body.style.overflow = previousOverflow;
        body.style.paddingRight = previousPadding;
    };
};
//# sourceMappingURL=scroll-lock.js.map